import { render } from "./etRichTextBox.vue?vue&type=template&id=0aa9895a"
import script from "./etRichTextBox.vue?vue&type=script&lang=js"
export * from "./etRichTextBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__